export default "__VITE_ASSET__485c77e9__"